import { Preset } from '@/types/global'

/* eslint-disable no-unused-vars */
export enum QUERY {
  PAGE = 'page',
  LIMIT = 'limit',
  SEARCH = 'search',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  TAG = 'tags',
  DIALOG = 'dialog',
}
export const FAQ_PAGE_SIZE = 10
export const FILE_PAGE_SIZE = 10
export const WEBSITE_PAGE_SIZE = 10
export const MAX_PINNED_FAQS = 5
export const HISTORY_PAGE_SIZE = 10
export const KEYWORD_PAGE_SIZE = 10
export const NOTIFICATION_SUBSCRIPTION_PAGE_SIZE = 10
export const NOTIFICATION_PAGE_SIZE = 10

export const DOTS = '...'

export enum PAGES_LINKS {
  FAQ = 'faq',
}
export enum CACHE_TAG {
  USER_SUBSCRIPTION_STATUS = 'user-subscription-status',
  USER_SUBSCRIPTION = 'user-subscription',
  HISTORY_LIST = 'history-list',
}

export const DATE_TIME_FORMAT = {
  en: {
    DATE_FORMAT: 'DD MMMM YYYY',
    DATE_TIME_FULL_FORMAT: 'DD MMMM YYYY, HH:mm',
    DATE_TIME_SORT_FORMAT: 'DD MMM YYYY, HH:mm',
    TIME_FORMAT: 'HH:mm',
    TIME_FORMAT_12: 'hh:mm a',
  },
  vi: {
    DATE_FORMAT: 'DD [tháng] MM, YYYY',
    DATE_TIME_FULL_FORMAT: 'DD [tháng] MM YYYY, HH:mm',
    DATE_TIME_SORT_FORMAT: 'DD/MM/YYYY, HH:mm',
    TIME_FORMAT: 'HH:mm',
    TIME_FORMAT_12: 'hh:mm a',
  },
  ja: {
    DATE_FORMAT: 'YYYY年MM月DD日',
    DATE_TIME_FULL_FORMAT: 'YYYY年MM月DD日, HH:mm',
    DATE_TIME_SORT_FORMAT: 'YYYY年MM月DD日, HH:mm',
    TIME_FORMAT: 'HH:mm',
    TIME_FORMAT_12: 'Ah[時]mm[分]',
  },
}

export const PRESETS = (locale: 'en' | 'vi' | 'ja'): Preset[] => [
  { name: 'allTime', label: locale === 'vi' ? 'Tất cả' : locale === 'ja' ? '全期間' : 'All time' },
  { name: 'last7', label: locale === 'vi' ? '7 ngày qua' : locale === 'ja' ? '直近7日間' : 'Last 7 days' },
  { name: 'last14', label: locale === 'vi' ? '14 ngày qua' : locale === 'ja' ? '直近14日間' : 'Last 14 days' },
  { name: 'last30', label: locale === 'vi' ? '30 ngày qua' : locale === 'ja' ? '直近30日間' : 'Last 30 days' },
  { name: 'last6Months', label: locale === 'vi' ? '6 tháng qua' : locale === 'ja' ? '過去6ヶ月間' : 'Last 6 months' },
  {
    name: 'last12Months',
    label: locale === 'vi' ? '12 tháng qua' : locale === 'ja' ? '過去12ヶ月間' : 'Last 12 months',
  },
  { name: 'custom', label: locale === 'vi' ? 'Tùy chỉnh' : locale === 'ja' ? 'カスタム' : 'Custom' },
]

export const TANSTACK_QUERY_DEFAULT_STALE_TIME = 30 * 1000 // 30 seconds

export const TANSTACK_QUERY_DEFAULT_GC_TIME = 10 * 60 * 1000 // 10 minutes

export const PREFETCH_STALE_TIME = 120 * 1000

export const DEFAULT_FETCH_DEBOUNCE = 500

export enum QUERY_KEY {
  CHATBOT_CONFIG = 'chatbot-config',
  CHATBOT_PASSWORD = 'chatbot-password',
  TAGS = 'tags',
  FAQS = 'faqs',
  KEYWORDS = 'keywords',
  NOTIFICATIONS = 'notifications',
  WEB_PUSH_NOTIFICATION_SUBSCRIPTION = 'web-push-notification-subscription',
  CHATBOT_LLM_CONFIGURATION = 'chatbot-llm-configuration',
  MCP_SERVER = 'mcp-servers',
  INGESTION_FILES = 'ingestion-files',
  TRAINING_WEBSITES = 'training-websites',
  TRAINING_WEBSITES_PROCESSING = 'training-websites-processing',
  TRAINING_WEBSITE_DOCUMENTS = 'training-website-documents',
  ADDON_CATALOG = 'addon-catalog',
  ADDON_STATE = 'addon-state',
  ADDON_PREVIEW = 'addon-preview',
  LIMIT_USAGE = 'limit-usage',
  ORGANIZATION = 'organization',
  ORGANIZATION_USERS = 'organization-users',
  SUBSCRIPTION_PADDLE_DETAIL = 'subscription-paddle-detail',
  TERMINOLOGY_MAPPINGS = 'terminology-mappings',
  ONBOARDING_STATUS = 'onboarding-status',
  API_KEYS = 'api-keys',
  API_KEY_PERMISSIONS = 'api-key-permissions',
  ESCALATED_CONVERSATIONS = 'escalated-conversations',
  ESCALATED_STATUS = 'escalated-status',
  CONTACT_COLLECTION_COUNT = 'contact-collection-count',
  ALL_CONVERSATIONS_COUNT = 'all-conversations-count',
  ACTIVE_RELEASE = 'active-release',
  HISTORY_DETAIL = 'history-detail',
  FACEBOOK = 'facebook',
  ANALYTICS_OVERVIEW = 'analytics-overview',
  EXPORTABLE_COUNTS = 'exportable-counts',
}

export enum CHAT_INTERFACE_TABS {
  CONVERSATION = 'conversation',
  COLLECTION = 'collection',
}

export const PADDLE_CURRENCY_DECIMAL_PRECISION = {
  USD: 2,
  EUR: 2,
  GBP: 2,
  ARS: 2,
  AUD: 2,
  BRL: 2,
  CAD: 2,
  CHF: 2,
  CNY: 2,
  COP: 2,
  CZK: 2,
  DKK: 2,
  HKD: 2,
  HUF: 2,
  ILS: 2,
  INR: 2,
  JPY: 0,
  KRW: 0,
  MXN: 2,
  NOK: 2,
  NZD: 2,
  PLN: 2,
  RUB: 2,
  SEK: 2,
  SGD: 2,
  THB: 2,
  TRY: 2,
  TWD: 2,
  UAH: 2,
  VND: 0,
  ZAR: 2,
} as const

export const SIGN_UP_ERROR_NAME = {
  SIGN_UP_ERROR_EXCEPTION: 'SignUpErrorException',
  INVALID_PASSWORD_EXCEPTION: 'InvalidPasswordException',
  HARD_LOCKED_USER_EXCEPTION: 'HardLockedUserException',
  CODE_MISMATCH_EXCEPTION: 'CodeMismatchException',
  EXPIRED_CODE_EXCEPTION: 'ExpiredCodeException',
} as const

export const RESET_PASSWORD_ERROR_NAME = {
  INVALID_PASSWORD_EXCEPTION: 'InvalidPasswordException',
  PASSWORD_HISTORY_POLICY_VIOLATION_EXCEPTION: 'PasswordHistoryPolicyViolationException',
  CODE_MISMATCH_EXCEPTION: 'CodeMismatchException',
  EXPIRED_CODE_EXCEPTION: 'ExpiredCodeException',
  INVALID_TOKEN_EXCEPTION: 'InvalidTokenException',
} as const

export const ACCOUNT_SECURITY_ERROR_NAME = {
  INVALID_CURRENT_PASSWORD: 'InvalidCurrentPassword',
  INVALID_PASSWORD_EXCEPTION: 'InvalidPasswordException',
  PASSWORD_HISTORY_POLICY_VIOLATION_EXCEPTION: 'PasswordHistoryPolicyViolationException',
} as const

export const DIALOG_PARAMS = {
  BILLING: 'billing',
  FEEDBACK: 'feedback',
  LEGAL: 'legal',
  USER_PREFERENCES: 'user-preferences',
} as const

export const URL_REGEX = /^(http:\/\/|https:\/\/)([a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+)(:\d+)?(\/[^\s]*)?$/
export const CHATBOT_CONVERSATION_STYLE = {
  BALANCED: 'balanced',
  CUSTOMER_SERVICE_AGENT: 'customerServiceAgent',
  TUTOR: 'tutor',
  CUSTOM: 'custom',
} as const

// @TODO: This is only temporary, remove once BE error code is standardized.
//        Cannot manually check in FE for error since some list are lazy loaded.
export const BE_LOCALE_ERROR_MESSAGES = {
  FAQ: {
    EXIST_NAME: new Set([
      'Custom answer name already exists',
      'カスタム回答名は既に存在します',
      'Tên câu trả lời tùy chỉnh đã tồn tại',
    ]),
  },
  KEYWORD: {
    EXIST_NAME: new Set(['Keyword name already exists', 'キーワード名は既に存在します', 'Tên từ khoá đã tồn tại']),
  },
} as const

export const USER_AGENT_DEVICE_TYPE = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
} as const

export const AUTH_JWT_TOKEN_KEY = 'kotae-auth.jwt_token'
export const AUTH_SESSION_TOKEN_KEY = 'kotae-auth.session_token'
export const AUTH_SECURE_SESSION_TOKEN_KEY = '__Secure-kotae-auth.session_token' // in real env, this is the one that is used from auth social login -> FE
export const AUTH_HEADER_SET_TOKEN_KEY = 'set-auth-token'

export const REVALIDATE_TIME = {
  SHORT: 5, // 5 seconds, usually to prevent consecutive requests
  TEN_MINUTES: 60 * 10,
}

export const FETCH_RETRY_COUNT = 1
export const FETCH_RETRY_DELAY = 1000

export const TAILWIND_BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  XL2: 1536,
} as const

export const TAILWIND_CONTAINER_QUERY_BREAKPOINTS = {
  XS: 320,
  SM: 384,
  MD: 448,
  LG: 512,
  XL: 576,
  XL2: 672,
  XL3: 768,
  XL4: 896,
  XL5: 1024,
  XL6: 1152,
  XL7: 1280,
} as const

export const DEFAULT_LLM_CONFIG = {
  promptResponseStyle: CHATBOT_CONVERSATION_STYLE.BALANCED,
  customPromptResponse: '',
} as const

export enum FLAG_FEATURE {
  ADDON = 'addon',
}
